export const rootUrl = 'https://allscoreslive.com/';
export const localUrl = 'https://allscoreslive.com/asl/';
export const flagUrl = 'https://allscoreslive.com/common/flags/';
export const imgUrl = 'https://allscoreslive.com/common/images/';
export const playerUrl = 'https://allscoreslive.com/common/players/';

export function getAuth(user) {
  const binary = createBinaryString(Number(user.auth));
  const auth = {
    isAdmin: binary[31],
    isDelegate: binary[30],
    isTDirector: binary[29]
  };
  user.auth = auth;
  return user;
}

export function setAuth(user) {
  return Number(user.auth.isAdmin) * 1
    + Number(user.auth.isDelegate) * 2
    + Number(user.auth.isTDirector) * 4
    ;
}

function createBinaryString(nMask) {
  // nMask must be between -2147483648 and 2147483647
  for (var nFlag = 0, nShifted = nMask, sMask = ""; nFlag < 32;
    nFlag++, sMask += String(nShifted >>> 31), nShifted <<= 1);
  return sMask;
}

export function getHtmlString(str) {
  const parser = new DOMParser();
  return parser.parseFromString(`<!doctype html><body>${str}`, 'text/html').body.textContent;
}

export function getOrgBio(org, player) {
  if (!player || !player.meta) return "";
  switch (org) {
    case "upg":
      return player.meta.upgbio;
    case "upusa":
      return player.meta.upusabio;
    case "epa":
      return player.meta.epabio;
    case "fbep":
      return player.meta.fbepbio;
    case "irpt":
      return player.meta.irptbio;
    default:
      return "";
  }
}

export function ifTiedInPoints(prm, ranking) {
  if (Number(prm.iftied) === 0) {
    return ranking;
  }
  let swapped = true;
  function swapRanking(r1, r2) {
    const tmp = ranking[r1];
    ranking[r1] = ranking[r2];
    ranking[r2] = tmp;
    swapped = true;
  }
  while (swapped) {
    swapped = false;
    for (let r = 0; r < ranking.length - 1; r++) {
      if (Number(ranking[r].t) === Number(ranking[r + 1].t)) {
        const p1 = ranking[r].p;
        const p2 = ranking[r + 1].p;
        /* A- If players are level on the same number of points, positions are determined by whoever won 
           the most points in any single event during the season. */
        let max1 = 0;
        p1.forEach(p => max1 = Math.max(max1, Number(p.p ? p.p : 0)));
        let max2 = 0;
        p2.forEach(p => max2 = Math.max(max2, Number(p.p ? p.p : 0)));
        if (max1 < max2) {
          swapRanking(r, r + 1);
        } else {
          if (max1 === max2) {
            /* B- If positions can’t be decided by (A) the countback method will be applied.
               1. This means positions will be decided by how many points were earned from 
               the most recently numbered event on this season’s Professional Series. 
               2. Should this still not separate players, you continue this process 
               looking at events working backwards (most recently numbered) throughout 
               the season until players can be separated.*/
            if (max1 > 0) {
              for (let i = p1.length - 1; i >= 0; i--) {
                max1 = Number(p1[i].p ? p1[i].p : 0);
                max2 = Number(p2[i].p ? p2[i].p : 0);
                if (max1 === max2) continue;
                if (max1 < max2) {
                  swapRanking(r, r + 1);
                }
                break;
              }
            }
            /* C) If players have an exactly identical ranking points record throughout the entire season, 
               positions will be decided by whoever won the greatest accumulated number of frames (from both events) 
               throughout the most recent long-weekend on this season’s Professional Series. */

            /* D) In the event that players still can’t be separated, the players involved may have 
               to contest a playoff – the details of which would be decided by the Ultimate Pool Group. */
          }
        }
      }
    }
  }
  return ranking;
}

export function implode(rankings) {
  rankings.forEach(r => {
    r.categs = [];
    r.events.forEach(e => {
      let categ = r.categs.find(c => c.code === e.categ);
      if (!categ) {
        categ = { code: e.categ, events: [] };
        r.categs.push(categ);
      }
      categ.events.push({ code: e.event });
    })
  })
  return rankings;
}

export function replaceParm(str, params) {
  let res = str;
  if (str.includes("{") && str.includes("}")) {
    // Si params est une chaîne simple (sans accolades), l'utiliser directement
    if (typeof params === 'string' && !params.includes("{")) {
      res = str.replace(/{[^}]+}/, params);
    } else if (typeof params === 'string') {
      // Parser la chaîne comme un objet JavaScript
      try {
        // eslint-disable-next-line no-new-func
        const paramsObj = new Function('return ' + params)();
        res = str.replace(/{([^}]+)}/g, (match, key) => {
          return paramsObj[key] !== undefined ? paramsObj[key] : match;
        });
      } catch (e) {
        return getHtmlString(res);
      }
    } else {
      // params est déjà un objet
      res = str.replace(/{([^}]+)}/g, (match, key) => {
        return params[key] !== undefined ? params[key] : match;
      });
    }
  }
  return getHtmlString(res);
}

export function get6RS(chrono) {
  let res = "";
  if (chrono) {
    if (chrono.substring(0, 8) === "00:59:59") {
      res = " (No Time) ";
    } else {
      if (chrono !== "00:00:00.00") {
        res = " (" + chrono.replaceAll("00:", "") + ") ";
      }
    }
  }
  return res;
}

export function get6RSRanking(chrono) {
  let res = "";
  if (chrono) {
    if (chrono.substring(0, 8) === "00:59:59") {
      res = "No Time";
    } else {
      if (chrono !== "00:00:00.00") {
        res = chrono.replaceAll("00:", "");
      }
    }
  }
  return res;
}

export function formatID(phase, match) {
  let id = phase.prefix;
  const ids = "ABCDEFGHIJKLMNOPQRSTUVWXYZ";
  if (Number(phase.nbGrps) > 1) {
    let group = Number(match.id.substr(4, 2));
    if (phase.mdGrps === "A") {
      group = ids[group];
    } else {
      group = ("0" + (group + 1)).slice(-2);
    }
    id = id + group + "#" + match.id.substr(7, 3);
  } else {
    id = id + "#" + match.id.substr(4, 7);
  }
  return id;
}

export function getScore1(match, set) {
  let score1 = 0;
  match.sets.filter(s => Number(s.set) === set).forEach((s) => {
    score1 += Number(s.sc1);
  })
  return score1;
}

export function getScore2(match, set) {
  let score2 = 0;
  match.sets.filter(s => Number(s.set) === set).forEach((s) => {
    score2 += Number(s.sc2);
  })
  return score2;
}

export function getYoutubeId(url) {
  var regExp = /^.*((youtu.be\/)|(v\/)|(\/u\/\w\/)|(embed\/)|(watch\?))\??v?=?([^#&?]*).*/;
  var match = url.match(regExp);
  return (match && match[7].length === 11) ? match[7] : false;
}

export function formatSet(set) {
  if (isNaN(set)) return set;
  let res = Math.trunc(set).toString();
  const dec = set - Math.trunc(set);
  if (dec === 0.5) {
    res += "½";
  }
  return res;
}

export function getGroupLabel(phase, grp) {
  const ids = "ABCDEFGHIJKLMNOPQRSTUVWXYZ";
  if (phase.mdGrps === "A") {
    return ids[Number(grp)];
  } else {
    return (Number(grp) + 1);
  }
}

function hexToRgb(hex) {
  var result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);
  return result ? {
    r: parseInt(result[1], 16),
    g: parseInt(result[2], 16),
    b: parseInt(result[3], 16)
  } : null;
}

function componentToHex(c) {
  var hex = c.toString(16);
  return hex.length === 1 ? "0" + hex : hex;
}

function rgbToHex(r, g, b) {
  return "#" + componentToHex(r) + componentToHex(g) + componentToHex(b);
}

export function getNearColor(color, delta) {
  const rgb = hexToRgb(color);
  const r = Math.min(rgb.r + delta, 255);
  const g = Math.min(rgb.g + delta, 255);
  const b = Math.min(rgb.b + delta, 255);
  return rgbToHex(r, g, b);
}

export function getOtherCateg(categs, table, name) {
  const phasecode = Number(name.substr(1, 2));
  let otherCateg = null;
  categs.forEach((categ) => {
    if (categ.phases.length > phasecode) {
      let found = -1;
      if (name.substr(7, 1) === "G") {
        found = categ.phases[phasecode].moves.findIndex(m => m.wcateg === table.c);
      } else {
        found = categ.phases[phasecode].moves.findIndex(m => m.lcateg === table.c);
      }
      if (found >= 0) {
        otherCateg = categ;
        return otherCateg;
      }
    }
  })
  return otherCateg;
}

export function getPlayerName(t, categs, categ, table, code, pname) {
  if (Number(code) === -2) return "TBA";
  if (Number(code.toString().substr(0, 2)) === -2) return "TBA #" + Number(code.toString().substr(2));
  if (Number(code) < 0) return "BYE";
  if (Number(code) !== 0) return pname;
  let phase = categ.phases[Number(table.id.substr(1, 2))];
  let group = null;
  let rank = null;
  if (pname.substr(0, 1) === "P" && pname.substr(3, 1) === "#" && pname.length === 6 && phase.tirage === "L") {
    phase = categ.phases[Number(pname.substr(1, 2))];
    return t('drawnfrom1n', { phase: phase.lib, max: phase.nbQlfs });
  }
  if (pname.trim().length === 4 && pname.substr(0, 1) === "P" && pname.substr(3, 1) === "W") {
    phase = categ.phases[Number(pname.substr(1, 2))];
    return t('drawnfrom', { phase: phase.lib });
  }
  if (pname === "RND") {
    return t('rnd');
  }
  let comeFromOtherCateg = 0;
  if (pname.substr(0, 1) === "C") {
    pname = pname.substring(1);
    comeFromOtherCateg = getOtherCateg(categs, table, pname);
    if (pname.substr(0, 1) === "P") {
      phase = comeFromOtherCateg.phases[Number(pname.substr(1, 2))];
      if (pname.substr(3, 1) === "G") {
        group = getGroupLabel(phase, pname.substr(4, 2));
        if (pname.substr(6, 1) === "#") {
          if (phase.mode === "SE" && pname.length === 11) {
            let gp = pname.substr(10, 1);
            if (gp === "G") {
              return t('winnerOf', { match: phase.prefix + group + "#" + pname.substr(7, 3) });
            } else {
              return t('loserOf', { match: phase.prefix + group + "#" + pname.substr(7, 3) });
            }
          } else {
            rank = Number(pname.substr(7));
            const grouplib = Number(phase.nbGrps) === 1 ? phase.lib : t('group', { grp: group });
            if (rank === 1) {
              return grouplib + t('winner');
            }
            if (rank === 2) {
              return grouplib + t('runnerUp');
            }
            if (rank === 3) {
              return grouplib + t('thirdPlace');
            }
            if (rank > 3) {
              return grouplib + t('nPlace', { n: rank });
            }
          }
        }
      }
      if (pname.substr(3, 1) === "#") {
        rank = Number(pname.substr(4, 3));
        let gp = pname.substr(7, 1);
        if (gp === "G") {
          return t('winnerOf', { match: phase.lib + " #" + pname.substr(4, 3) });
        } else {
          return t('loserOf', { match: phase.lib + " #" + pname.substr(4, 3) });
        }
      }
      if (pname.substr(3, 1) === "R") {
        rank = Number(pname.substr(4, 2));
        const all = pname.includes("*");
        if (rank === 1) {
          return all ? t('groups1n', { nb: phase.nbGrps }) + t('winner') : t('bestWinner');
        }
        if (rank === 2) {
          return all ? t('groups1n', { nb: phase.nbGrps }) + t('runnerUp') : t('bestRunnerUp');
        }
        if (rank === 3) {
          return all ? t('groups1n', { nb: phase.nbGrps }) + t('thirdPlace') : t('bestThirdPlace');
        }
        if (rank > 3) {
          return all ? t('groups1n', { nb: phase.nbGrps }) + t('nPlace', { n: rank }) : t('bestNPlace', { n: rank });
        }
      }
    }
  }
  if (pname.substr(0, 1) === "P") {
    phase = categ.phases[Number(pname.substr(1, 2))];
    if (pname.substr(3, 1) === "G") {
      group = getGroupLabel(phase, pname.substr(4, 2));
      if (pname.substr(6, 1) === "#") {
        if ((phase.mode === "SE" || phase.mode === "2K") && pname.length === 11) {
          let gp = pname.substr(10, 1);
          if (gp === "G") {
            return t('winnerOfMatch', { match: phase.prefix + group + "#" + pname.substr(7, 3) });
          } else {
            return t('loserOfMatch', { match: phase.prefix + group + "#" + pname.substr(7, 3) });
          }
        } else {
          rank = Number(pname.substr(7));
          const grouplib = Number(phase.nbGrps) === 1 ? phase.lib : t('group', { grp: group });
          if (rank === 1) {
            return grouplib + t('winner');
          }
          if (rank === 2) {
            return grouplib + t('runnerUp');
          }
          if (rank === 3) {
            return grouplib + t('thirdPlace');
          }
          if (rank > 3) {
            return grouplib + t('nPlace', { n: rank });
          }
        }
      }
    }
    if (pname.substr(3, 1) === "#") {
      rank = Number(pname.substr(4, 3));
      let gp = pname.substr(7, 1);
      if (gp === "G") {
        return t('winnerOfMatch', { match: phase.prefix + "#" + pname.substr(4, 3) });
      } else {
        return t('loserOfMatch', { match: phase.prefix + "#" + pname.substr(4, 3) });
      }
    }
    if (pname.substr(3, 1) === "R") {
      rank = Number(pname.substr(4, 2));
      const all = pname.includes("*");
      if (rank === 1) {
        return all ? t('groups1n', { nb: phase.nbGrps }) + t('winner') : t('bestWinner');
      }
      if (rank === 2) {
        return all ? t('groups1n', { nb: phase.nbGrps }) + t('runnerUp') : t('bestRunnerUp');
      }
      if (rank === 3) {
        return all ? t('groups1n', { nb: phase.nbGrps }) + t('thirdPlace') : t('bestThirdPlace');
      }
      if (rank > 3) {
        return all ? t('groups1n', { nb: phase.nbGrps }) + t('nPlace', { n: rank }) : t('bestNPlace', { n: rank });
      }
    }
  }
  return pname;
}

export function computeRanking(categ, parms, shootout, tables) {
  let ctgs = [];
  if (Number(categ.code) < 0) return ctgs;
  tables.forEach((table) => {
    const parm = parms.find(p => p.categ === table.c);
    let ctg = ctgs.find(c => c.code === Number(table.c));
    if (!ctg) {
      ctg = { code: Number(table.c), title: replaceParm(categ.name, parm.parm), type: categ.type, phases: [] };
      ctgs.push(ctg);
    }
    let phase = ctg.phases.find(p => p.code === Number(table.p));
    if (!phase) {
      const phs = categ.phases[Number(table.p)];
      phase = {
        code: Number(table.p),
        mode: phs.mode,
        mnull: phs.mnull,
        tied: phs.tied,
        grptied: phs.grptied,
        grpshd: phs.grpshd,
        grpshq: phs.grpshq,
        mdGrps: phs.mdGrps,
        nbGrps: phs.nbGrps,
        nbQlfs: phs.nbQlfs,
        boSets: phs.boSets,
        snull: phs.snull,
        stied: phs.stied,
        ptswon: phs.winner,
        ptstie: phs.tie,
        ptslost: phs.looser,
        ptsfrm: phs.ptsfrm,
        grps: []
      };
      ctg.phases.push(phase);
    }
    let grp = phase.grps.find(g => Number(g.code) === Number(table.g));
    if (!grp) {
      grp = { code: table.g, ranking: [], draws: [], players: [] };
      phase.grps.push(grp);
    }
    grp.draws.push(table);
  })
  ctgs.forEach((ctg) => {
    ctg.phases.forEach((phase) => {
      phase.grps.forEach((grp) => {
        grp.isEnded = true;
        grp.draws.forEach((draw) => {
          if (!draw.me) {
            grp.isEnded = false;
          }
          let rank = grp.ranking.find(r => r.t1j1 === Number(draw.t1j1));
          let shoot = shootout.find(s => Number(s.c) === Number(ctg.code) && Number(s.p) === Number(phase.code) && Number(s.g) === Number(grp.code) && Number(s.t1j1) === Number(draw.t1j1));
          if (!rank) {
            rank = {
              t1j1: Number(draw.t1j1),
              t1n1: draw.t1n1,
              t1p1: draw.t1p1,
              t1c1: draw.t1c1,
              t1j2: Number(draw.t1j2),
              t1n2: draw.t1n2,
              t1p2: draw.t1p2,
              t1c2: draw.t1c2,
              played: 0,
              won: 0,
              tie: 0,
              lost: 0,
              setplayed: 0,
              setwon: 0,
              settie: 0,
              setlost: 0,
              frmwon: 0,
              frmlost: 0,
              cfwon: 0,
              cflost: 0,
              points: 0,
              goal: 0,
              sh: shoot ? shoot.sh : null,
              tm: draw.tm1,
              res: []
            }
            grp.ranking.push(rank);
          } else {
            rank.sh = shoot ? shoot.sh : null;
          }
          if (draw.me) {
            rank.res.push({
              i: Number(draw.t2j1),
              n: draw.t2n1,
              p: draw.t2p1,
              c: draw.t2c1,
              sc1: draw.sets[0].sc1,
              sc2: draw.sets[0].sc2
            });
          }
          if (draw.me) {
            rank.played++;
            if (Number(draw.st1) > Number(draw.st2)) {
              rank.won++;
              rank.points += Number(phase.ptswon);
            }
            if (Number(draw.st1) === Number(draw.st2)) {
              if (Number(phase.tied) === 1) {
                if (draw.sh1 < draw.sh2) {
                  rank.won++;
                  rank.points += Number(phase.ptswon);
                } else {
                  rank.lost++;
                  rank.points += Number(phase.ptslost);
                }
              } else {
                if (Number(draw.sets[0].sc1) > Number(draw.sets[0].sc2)) {
                  rank.won++;
                  rank.points += Number(phase.ptswon);
                }
                if (Number(draw.sets[0].sc2) > Number(draw.sets[0].sc1)) {
                  rank.lost++;
                  rank.points += Number(phase.ptslost);
                }
                if (draw.sets[0].sc1 === draw.sets[0].sc2) {
                  rank.tie++;
                  rank.points += Number(phase.ptstie);
                }
              }
            }
            if (Number(draw.st1) < Number(draw.st2)) {
              rank.lost++;
              rank.points += Number(phase.ptslost);
            }
            if (Number(phase.ptsfrm) === 1) {
              rank.points += Number(draw.sets[0].sc1);
            }
            draw.sets.forEach((set) => {
              rank.setplayed++;
              if (Number(set.sc1) > Number(set.sc2)) rank.setwon++;
              if (Number(set.sc1) === Number(set.sc2)) {
                if (Number(phase.tied) === 1) {
                  if (set.sh1 < set.sh2) rank.setwon++;
                  if (set.sh1 > set.sh2) rank.setlost++;
                } else {
                  rank.settie++;
                }
              }
              if (Number(set.sc1) < Number(set.sc2)) rank.setlost++;
              rank.frmwon += Number(set.sc1);
              rank.frmlost += Number(set.sc2);
              rank.cfmwon += Number(set.cf1);
              rank.cflost += Number(set.cf2);
              if (ctg.type === "T" && (phase.mode === "RR" || phase.mode === "C1" || phase.mode === "C2" || phase.mode === "C3") && Number(phase.nbGrps) === 1) {
                set.frms.filter(f => Number(f.t1j2) === 0 && Number(f.t2j2) === 0).forEach((frm) => {
                  let p1 = grp.players.find(p => p.i === frm.t1j1);
                  if (!p1) {
                    p1 = { i: frm.t1j1, n: frm.t1n1, p: frm.t1p1, c: frm.t1c1, t: draw.t1n1, played: 0, won: 0 };
                    grp.players.push(p1);
                  }
                  p1.played++;
                  if (Number(frm.sc1) > Number(frm.sc2)) p1.won++;
                  let p2 = grp.players.find(p => p.i === frm.t2j1);
                  if (!p2) {
                    p2 = { i: frm.t2j1, n: frm.t2n1, p: frm.t2p1, c: frm.t2c1, t: draw.t2n1, played: 0, won: 0 };
                    grp.players.push(p2);
                  }
                  p2.played++;
                  if (Number(frm.sc2) > Number(frm.sc1)) p2.won++;
                })
              }
            })
          }
          rank = grp.ranking.find(r => r.t1j1 === Number(draw.t2j1));
          shoot = shootout && shootout.find(s => Number(s.c) === ctg.code && Number(s.p) === phase.code && Number(s.g) === Number(grp.code) && Number(s.t1j1) === Number(draw.t2j1));
          if (!rank) {
            rank = {
              t1j1: Number(draw.t2j1),
              t1n1: draw.t2n1,
              t1p1: draw.t2p1,
              t1c1: draw.t2c1,
              t1j2: Number(draw.t2j2),
              t1n2: draw.t2n2,
              t1p2: draw.t2p2,
              t1c2: draw.t2c2,
              played: 0,
              won: 0,
              tie: 0,
              lost: 0,
              setplayed: 0,
              setwon: 0,
              settie: 0,
              setlost: 0,
              frmwon: 0,
              frmlost: 0,
              cfwon: 0,
              cflost: 0,
              points: 0,
              goal: 0,
              sh: shoot ? shoot.sh : null,
              tm: draw.tm2,
              res: []
            }
            grp.ranking.push(rank);
          } else {
            rank.sh = shoot ? shoot.sh : null;
          }
          if (draw.me) {
            rank.res.push({
              i: Number(draw.t1j1),
              n: draw.t1n1,
              p: draw.t1p1,
              c: draw.t1c1,
              sc1: draw.sets[0].sc2,
              sc2: draw.sets[0].sc1
            });
          }
          if (draw.me) {
            rank.played++;
            if (Number(draw.st2) > Number(draw.st1)) {
              rank.won++;
              rank.points += Number(phase.ptswon);
            }
            if (Number(draw.st2) === Number(draw.st1)) {
              if (Number(phase.tied) === 1) {
                if (draw.sh2 < draw.sh1) {
                  rank.won++;
                  rank.points += Number(phase.ptswon);
                } else {
                  rank.lost++;
                  rank.points += Number(phase.ptslost);
                }
              } else {
                if (Number(draw.sets[0].sc1) < Number(draw.sets[0].sc2)) {
                  rank.won++;
                  rank.points += Number(phase.ptswon);
                }
                if (Number(draw.sets[0].sc2) < Number(draw.sets[0].sc1)) {
                  rank.lost++;
                  rank.points += Number(phase.ptslost);
                }
                if (draw.sets[0].sc1 === draw.sets[0].sc2) {
                  rank.tie++;
                  rank.points += Number(phase.ptstie);
                }
              }
            }
            if (Number(draw.st2) < Number(draw.st1)) {
              rank.lost++;
              rank.points += Number(phase.ptslost);
            }
            if (Number(phase.ptsfrm) === 1) {
              rank.points += Number(draw.sets[0].sc2);
            }
            draw.sets.forEach((set) => {
              rank.setplayed++;
              if (Number(set.sc2) > Number(set.sc1)) rank.setwon++;
              if (Number(set.sc2) === Number(set.sc1)) {
                if (Number(phase.tied) === 1) {
                  if (set.sh2 < set.sh1) rank.setwon++;
                  if (set.sh2 > set.sh1) rank.setlost++;
                } else {
                  rank.settie++;
                }
              }
              if (Number(set.sc2) < Number(set.sc1)) rank.setlost++;
              rank.frmwon += Number(set.sc2);
              rank.frmlost += Number(set.sc1);
              rank.cfmwon += Number(set.cf2);
              rank.cflost += Number(set.cf1);
            })
          }
        })
        //Tri du classement
        grp.ranking.sort((a, b) => {
          if (a.points < b.points) return 1;
          if (a.points > b.points) return -1;
          //6 reds shootout
          if (a.points === b.points && grp.isEnded && Number(phase.grptied) === 1 && ((a.sh && a.sh.substring(0, 8) !== "00:59:59") || (b.sh && b.sh.substring(0, 8) !== "00:59:59"))) {
            if (a.sh && b.sh && a.sh > b.sh) return 1;
            if (a.sh && b.sh && a.sh < b.sh) return -1;
          }
          //Frame difference and head-to-head
          if (a.points === b.points && (!grp.isEnded || Number(phase.grptied) === 2 || (Number(phase.grptied) === 1 && a.sh && a.sh.substring(0, 8) === "00:59:59" && b.sh && b.sh.substring(0, 8) === "00:59:59"))) {
            if ((a.frmwon - a.frmlost) < (b.frmwon - b.frmlost)) return 1;
            if ((a.frmwon - a.frmlost) > (b.frmwon - b.frmlost)) return -1;
            if ((a.frmwon - a.frmlost) === (b.frmwon - b.frmlost)) {  //head-to-head
              const headToHead = grp.draws.filter(d => (Number(d.t1j1) === Number(a.t1j1) && Number(d.t2j1) === Number(b.t1j1)) || (Number(d.t1j1) === Number(b.t1j1) && Number(d.t2j1) === Number(a.t1j1)));
              let aWon = 0; let bWon = 0;
              let aFrms = 0; let bFrms = 0;
              headToHead.forEach(h => {
                if (Number(h.t1j1) === Number(a.t1j1)) {
                  if (Number(h.st1) > Number(h.st2)) aWon++;
                  if (Number(h.st1) < Number(h.st2)) bWon++;
                } else {
                  if (Number(h.st1) < Number(h.st2)) aWon++;
                  if (Number(h.st1) > Number(h.st2)) bWon++;
                }
                h.sets.forEach(s => {
                  if (Number(h.t1j1) === Number(a.t1j1)) {
                    aFrms += Number(s.sc1);
                    bFrms += Number(s.sc2);
                  } else {
                    aFrms += Number(s.sc2);
                    bFrms += Number(s.sc1);
                  }
                })
              })
              if (headToHead.length > 0) {
                if (aWon > bWon) {
                  return -1;
                }
                if (aWon < bWon) {
                  return 1;
                }
                if (aWon === bWon) {
                  if (aFrms > bFrms) {
                    return -1;
                  }
                  if (aFrms < bFrms) {
                    return 1;
                  }
                }
              }
            }
          }
          return 0;
        })
        //6 red shootout needed?
        grp.need6redshootout = false;
        if (grp.isEnded && Number(phase.grptied) === 1) {
          const nbqlfs = Number(phase.nbQlfs);
          const grpshQ = Number(phase.grpshq) === 1;
          const grpshD = Number(phase.grpshd) === 1;
          let pts = grp.ranking[0].points; let nq = 0;
          grp.ranking.forEach((rank, r) => {
            const hasnext = r < grp.ranking.length - 1;
            const nbsame = grp.ranking.filter((same, s) => s >= r && same.points === pts).length;
            if (r === 0) {
              pts = rank.points;
              if (grp.ranking[r + 1].points === pts) {
                if (grpshQ || (nbsame > nbqlfs)) {
                  rank.shootout = true;
                  grp.need6redshootout = true;
                } else {
                  nq++;
                }
              } else {
                nq++;
              }
            }
            if (r > 0) {
              if (rank.points === pts) {
                if (nq < nbqlfs) {
                  if (grpshQ || grp.ranking[r - 1].shootout) {
                    rank.shootout = true;
                    grp.need6redshootout = true;
                  } else {
                    nq++;
                  }
                } else {
                  if (grpshD && grp.ranking[r - 1].shootout) {
                    rank.shootout = true;
                    grp.need6redshootout = true;
                  }
                }
              } else {
                pts = rank.points;
                if (nq < nbqlfs) {
                  if (hasnext && grp.ranking[r + 1].points === pts) {
                    if (nbsame > (nbqlfs - nq) || (r + 1) <= nbqlfs) {
                      rank.shootout = true;
                      grp.need6redshootout = true;
                    } else {
                      nq++;
                    }
                  }
                } else {
                  if (grpshD) {
                    if (hasnext && grp.ranking[r + 1].points === pts) {
                      rank.shootout = true;
                      grp.need6redshootout = true;
                    }
                  }
                }
              }
            }
          })
        }
        //Tri des joueurs
        grp.players.sort((a, b) => {
          if (a.won < b.won) return 1;
          if (a.won > b.won) return -1;
          if (a.won === b.won) {
            if (a.played < b.played) return -1;
            if (a.played > b.played) return 1;
            return 0;
          }
          return 0;
        })
      })
    })
  })
  return ctgs;
}
